import { useCallback } from 'react';
import { bridge, isNotNil } from 'shared/src/utils';
import { AdAction } from 'shared/src/utils/eventLogger/adLogger/types';
import type { GoodsListCardItem } from '../utils/convertGoodsListItemToGoodsData';
import { getGoodsAnalytics } from './getGoodsAnalytics';

type Params = {
  type: string;
  listId: string | undefined;
  listParams: string | undefined;
};

export const useLogClickGoods = (params: Params) => {
  return useCallback(
    (pressed: GoodsListCardItem, index: number) => {
      bridge.logAnalyticsEvent({
        name: 'CLICK_GOODS',
        analytics: getGoodsAnalytics(pressed, index, params),
      });
      if (isNotNil(pressed.item.ad)) {
        bridge.logAdEvent({ action: AdAction.CLICK, ad: pressed.item.ad });
      }
    },
    [params],
  );
};
